import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import { typesOf } from './../util/util'
import { get } from './../network/request'
import {getCookie} from './../network/cookie'
const store = new Vuex.Store({
  state: {
    trackQueue: [],    //播放列表
    trackIndex: 0,     //当前播的第几本书
    bookIndex:0,       //正在播放的章节
    song: null,        //new audio对象
    duration: 0,       //音频的时长   单位是ms
    currentTime: 0,    //当前播放的时间   单位是ms
    timer: null,       //定时器
    loading: 0,        //下载进度   单位是s
    lyricObject: {},   //歌词
    currentIndex:0,    //当前显示歌词
    VariableHeight:0,   //歌词高度
    loopStyle:0,   //0:loop   1:shuffle    2 
    isPlay:false,
    showLogin:false,
    showVipQrcode:false,
    showFreeVip:false, 
    userInfo:{},
    title:'--一个专听国际书籍的APP,珠海动听科技有限公司',
    description:'路上畅听是一款现代化的移动学习产品，开小车、坐地铁、搭公交，一路听书是最好的选择，让用户的无聊碎片的时间变成力量与财富，来自最畅销书籍TOP100的有声书，15分钟读尽好书精华。横跨商业、科技、哲学、文史等优质内容，增长你的知识与技能，音频可听文字可视，任君挑选。',
    keywords:'车载FM,最畅销书籍TOP100,回声阅读,路上畅听FM,广播电台,一路听书,名人演讲,听演讲学英文,高清音频电台,儿童故事,微图书,free book,reading on the way'
  }, 
  mutations: {
    addQueue(state, item){
      if (!(state.trackQueue.some(function (val) {
          return val.bookId == item.bookId;
        }))) {
        state.trackQueue.push(item)
        state.trackIndex=state.trackQueue.length-1;
      }else{
        for (var i = 0; i < state.trackQueue.length; i++) {
          if (state.trackQueue[i].bookId === item.bookId) {
            state.trackQueue.splice(i, 1);
            break;
          }
      }
        state.trackQueue.unshift(item)
        state.trackIndex = state.trackQueue.indexOf(item)
      } 
    },
     
    addAll(state,arr){
      for(var i=arr.length-1; i>=0; i--){
          if (!(state.trackQueue.some(function (val) {
                  return val.bookId == arr[i].bookId
              }))) {
              state.trackQueue.unshift(arr[i])
          }
      }
      state.trackIndex=0;
    },
    loopFresh(state){
      state.loopStyle++;
      if(state.loopStyle==3){
          state.loopStyle=0;
      }
    },
    play(state){
        if(state.trackQueue.length == 0){
            alert('请先选择您想听的书')
            return
        }
         
      clearInterval(state.timer);
      state.VariableHeight=0;
      if (state.song.paused) {
        //console.log('play')
        state.song.play()
        //播放按钮状态
        state.isPlay = true;
        state.timer = setInterval(function () {
          state.currentTime += 1000;
          if (state.currentTime > state.duration) {
              state.currentTime = state.duration;
          }
            // 不能超过loading啊显然 loading是以秒为单位
           //if (state.currentTime > state.loading*1000) {
           //    state.currentTime = (state.loading+1)*1000;
           //}
          
        }, 1000)
      } else { 

        state.isPlay = false;
        state.song.pause()
      }
    }, 
    prev(state){
        if (state.trackQueue.length == 0 ) return
        if(state.bookIndex > 0){
            state.bookIndex--
        }else{
            state.bookIndex = 0
            if(state.trackIndex > 0){
                state.trackIndex--
            }else{
                state.trackIndex = 0
            }
        }

      
      clearInterval(state.timer) 
    },
    next(state){ 
  
        if (state.trackQueue.length == 0 ) {
            alert('已无下一本书');
            return
        }
        if(state.bookIndex < state.trackQueue[state.trackIndex].sectionList.length-1){
            state.bookIndex++

            //console.log(state.bookIndex)
        }else{
            state.bookIndex = 0;
            //如果没有下一节就返回下一本书 
            if(state.trackIndex < state.trackQueue.length - 1){
                state.trackIndex++ 
                
            }else{ 
                state.trackIndex=0
                state.song.pause()
                //播放按钮状态
                state.isPlay = false;
                alert('已播放完毕,点击重新收听') 
            }

            //console.log(state.trackIndex)
        } 
        clearInterval(state.timer)  
    },
    jump(state,per){
        state.currentTime=state.duration*per;
        state.song.currentTime=Math.floor(state.currentTime/1000);
    },
    drag(state,per){
        //drag和jump的不同是drag只控制进度条的长短。而jump切了歌的进度。
        //因为所有改变state的事件必须注册在这里。所以就定义了个这个事件
        //思考了一下，还是把控制进度条的事件和歌曲长短的事件分开了
        if(per<=0) per=0;
        if(per>=1) per=1;
        state.currentTime=state.duration*per;
    },
    random(state){
        state.trackIndex=Math.floor(state.trackQueue.length*Math.random());
        clearInterval(state.timer)
    },
    showLogin(state){
      state.showLogin = !state.showLogin;
    },
    showVipQrcode(state){
      state.showVipQrcode = !state.showVipQrcode;
    },
    showFreeVip(state){
      state.showFreeVip = !state.showFreeVip;
    },
    updateUserInfo(state, newUserInfo) {
      state.userInfo = newUserInfo;
    },
    
  },
  actions: {

    getMusicUrl ({commit, state}) {  
        if (state.trackQueue.length == 0 ) return
            var audioUrl = '';
            audioUrl = state.trackQueue[state.trackIndex].sectionList[state.bookIndex].proAudioUrl;
            if(audioUrl){
              audioUrl = audioUrl.replace('http://obj','https://objs')
            } else{
              audioUrl = state.trackQueue[state.trackIndex].sectionList[state.bookIndex].doubiAudioUrl;
              if(audioUrl){
                audioUrl = audioUrl.replace('http://obj','https://objs')
              }else{
                audioUrl = state.trackQueue[state.trackIndex].sectionList[state.bookIndex].enAudioUrl;
                if(audioUrl){
                  audioUrl = audioUrl.replace('http://obj','https://objs')
                }
              }
            }

            if (typesOf(state.song).includes('Null')) {
              state.song = new Audio(audioUrl); 
              state.song.addEventListener("ended", function () {  
                commit('next');    
            },false);
            } else {
                if(audioUrl == null || audioUrl == undefined){ 
                    state.bookIndex = 0;
                    if(getCookie('sessionId')){
                      state.showVipQrcode=!state.showVipQrcode
                    }else{
                      state.showLogin=!state.showLogin
                    }
                   
                    //alert('收听本章请先开通vip会员或付费购买本书')
                    return
                }else{
                    state.song.src = audioUrl;
                    state.currentTime = 0;
                }  
                
            }
            
            state.song.addEventListener("playing", function(){		//播放状态Doing 
              this.isPlay = true;//播放状态
            });
            state.song.addEventListener("pause", function(){		//播放状态Doing 
              this.isPlay = false;//播放状态
            });
            //等待有下载了，再play
            var isBuffered=true;
            state.song.addEventListener('progress', function () {
              if (this.buffered.length == 1) {
                if(isBuffered){ 
                    state.duration = parseInt(state.trackQueue[state.trackIndex].sectionList[state.bookIndex].proSec)*1000;
                    commit('play')//触发 
                    isBuffered=false;
                }
                var range = 0
                var bf = this.buffered
                var time = this.currentTime
                while (!(bf.start(range) <= time && time <= bf.end(range))) {
                  range += 1
                }
                var loadStartPercentage = bf.start(range)
                var loadEndPercentage = bf.end(range)
                state.loading = loadEndPercentage - loadStartPercentage
              }
            })
  
    
    },
    bookplay({commit,dispatch},bookId){  
      var listenUrl = 'xcx/listen-mode?bookId='+bookId+"&sessionId="+getCookie('sessionId'); 
      get(listenUrl).then(res => {
      commit('addQueue',res.data.data);
      dispatch('getMusicUrl');
    })
    },
    playbooklist({commit,dispatch},bookList){  
      commit('addAll',bookList); 
      dispatch('getMusicUrl');  
    },
  }
})

  
export default store